<!--Image carousel; (intended for staff images)
    Requires:
    - Any number of images
-->

<template>
  <main class="pt-5"> 
    <mdb-container v-if="block.value.title_and_text" class="justify-content-center">
      <mdb-row>
        <mdb-col class="text-center">
          <h2 v-if="block.value.title_and_text.title" class="pb-2">
            <strong>{{block.value.title_and_text.title}}</strong>
          </h2>
          <p v-if="block.value.title_and_text.text">{{block.value.title_and_text.text}}</p>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <mdb-container>
      <mdb-carousel :interval="8000" :items="images" indicators touch class="size z-depth-2">
        {{toImageArray()}}
      </mdb-carousel>
    </mdb-container>
  </main>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbCarousel } from "mdbvue";
export default {
  name: "ImageCarousel",
  props: {
    block: Object,
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCarousel
  },
  data() {
    return {
      images: []
    };
  },
  methods: {
    toImageArray: function() {
      var num_images = this.block.value.image_block.length;
      for (var i = 0; i < num_images; i++) {
        var image = {
          img: true,
          src: "" + this.block.value.image_block[i].value.image.image.src
        };
        image.caption = {
          title: this.block.value.image_block[i].value.caption
        };
        image.mask = "black-light";
        this.images[i] = image;
      }
    }
  }
};
</script>

<style scoped>

.size {
  max-height: 750px;
  max-width: 800px;
  margin: auto auto;
}
</style> 